import { setErrorReducer, setRequestReducer, setSuccessReducer } from '../helper';
import actions from './actions';

const initialState = {
    apps: [],
    appsReadAllState: false,
    appActivateState: false,
};

export default function appReducer(state = initialState, action = {}) {
    switch (action.type) {
        case actions.CP_READ_APPS_REQUEST:
            return setRequestReducer(state, 'appsReadAllState');
        case actions.CP_READ_APPS_SUCCESS: {
            return setSuccessReducer(state, 'appsReadAllState', {
                apps: action.apps,
            });
        }
        case actions.CP_READ_APPS_ERROR:
            return setErrorReducer(state, 'appsReadAllState');

        case actions.CP_ACTIVATE_APP_REQUEST:
            return setRequestReducer(state, 'appActivateState');
        case actions.CP_ACTIVATE_APP_SUCCESS:
            return setSuccessReducer(state, 'appActivateState', {
                apps: action.apps,
            });
        case actions.CP_ACTIVATE_APP_ERROR:
            return setErrorReducer(state, 'appActivateState');

        default:
            return state;
    }
}
